<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add a User
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.first_name"
                outlined
                label="First Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.first_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.middle_name"
                outlined
                label="Middle Name"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.middle_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.last_name"
                outlined
                label="Last Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.last_name"
              ></v-text-field>
            </v-col>
            <!-- <v-col sm="4">
              <v-text-field
                v-model="form.user_name"
                outlined
                label="User Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.user_name"
              ></v-text-field>
            </v-col> -->
            <v-col sm="4">
              <v-text-field
                v-model="form.email"
                outlined
                label="Email *"
                prepend-inner-icon="mdi-email"
                :error-messages="errors.email"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"
              ></v-text-field>
            </v-col>
            <!-- <v-col sm="4">
              <v-text-field
                v-model="form.referal_code"
                outlined
                label="Referal Code"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col> -->
            <!-- <v-col sm="4">
              <label>Upload Pic</label>
              <template>
                <div class="image-upload">
                  <input type="file" @change="handleFileChange" />
                  <div v-if="imageUrl" class="preview">
                    <img :src="imageUrl" alt="Preview" />
                  </div>
                </div>
              </template>
            </v-col> -->
            <!-- <v-col sm="4">
              <v-text-field
                v-model="form.otp"
                outlined
                label="OTP"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col> -->
            <!-- <v-col sm="4">
              <v-text-field
                v-model="form.opening_balance"
                outlined
                label="Opening Balance"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col> -->
            <!-- <v-col sm="4">
              <v-text-field
                v-model="form.wallet"
                outlined
                label="Current Balance"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col> -->
            <v-col sm="4">
              <v-text-field
                v-model="form.given_points"
                outlined
                label="Given Point"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.date"
                    label="Date"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="position"
                outlined
                v-model="form.position_id"
                :items="positionItems"
                label="Position *"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.position_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4" v-if="form.position_id == 4">
              <v-autocomplete
                ref="gst"
                outlined
                v-model="form.gst_type"
                :items="gstItems"
                label="Gst Type *"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.gst_type"
              ></v-autocomplete>
            </v-col>
            <v-col
              sm="4"
              v-if="
                form.position_id == 4 &&
                (form.gst_type == 2 || form.gst_type == 3)
              "
            >
              <v-text-field
                v-model="form.gst_certificate"
                outlined
                label="GST NO*"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.gst_certificate"
              ></v-text-field>
            </v-col>
            <v-col sm="4" v-if="form.position_id == 4">
              <v-autocomplete
                ref="is_loan_approved"
                outlined
                v-model="form.is_loan_approved"
                :items="typeItems"
                label="Loan Approved Status*"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.is_loan_approved"
              ></v-autocomplete>
            </v-col>
            <v-col
              sm="4"
              v-if="form.position_id == 4 && form.is_loan_approved == 1"
            >
              <v-autocomplete
                ref="action_type"
                outlined
                v-model="form.action_type"
                :items="actionItems"
                label="Action Type"
                prepend-inner-icon="mdi-account-tie-outline"
                :error-messages="errors.action_type"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4" v-if="form.position_id == 4 && form.action_type == 1">
              <v-text-field
                v-model="form.set_limit"
                outlined
                label="Set Limit"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.set_limit"
              ></v-text-field>
            </v-col>
            <v-col
              sm="4"
              v-if="form.position_id == 4 && form.is_loan_approved == 1"
            >
              <v-text-field
                v-model="form.loan_limit_amount"
                outlined
                disabled
                label="Loan Limit Amount"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4" v-if="form.position_id == 4 && form.action_type == 1">
              <v-text-field
                v-model="form.balance_amount"
                outlined
                label="Balance Amount"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-textarea
                v-model="form.address"
                outlined
                rows="4"
                label="Address*"
                prepend-inner-icon="mdi-map-marker-outline"
                :error-messages="errors.address"
              ></v-textarea>
            </v-col>
            <v-col sm="6">
              <v-textarea
                v-model="form.reason"
                outlined
                rows="4"
                label="Reason"
                prepend-inner-icon="mdi mdi-account-off-outline"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
            <v-col sm="4" v-if="form.position_id == 4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_point"
                inset
                :label="`Is Point: ${form.is_point ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="mt-5 mb-5"> </v-divider>
          <template v-if="form.position_id == 2">
            <h2>Working Details</h2>
            <br />
            <v-row>
              <v-col sm="3">
                <v-text-field
                  v-model="form.state_location"
                  outlined
                  label="State"
                  prepend-inner-icon="mdi-card-text-outline"
                  :error-messages="errors.state_location"
                ></v-text-field>
              </v-col>
              <v-col sm="3">
                <v-text-field
                  v-model="form.city"
                  outlined
                  label="City"
                  prepend-inner-icon="mdi-card-text-outline"
                  :error-messages="errors.city"
                ></v-text-field>
              </v-col>
              <v-col sm="3">
                <v-text-field
                  v-model="form.area"
                  outlined
                  label="Allocate Area"
                  prepend-inner-icon="mdi-card-text-outline"
                  :error-messages="errors.area"
                ></v-text-field>
              </v-col>
              <v-col sm="3">
                <v-text-field
                  v-model="form.pin_code"
                  outlined
                  label="Pin Code"
                  prepend-inner-icon="mdi-card-text-outline"
                  :error-messages="errors.pin_code"
                ></v-text-field>
              </v-col>
              <v-col sm="3">
                <v-autocomplete
                  ref="status"
                  outlined
                  v-model="form.status"
                  :items="statusItems"
                  label="Status"
                  prepend-inner-icon="mdi-arrow-expand-all"
                  :error-messages="errors.status"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </template>

          <template v-if="form.position_id == 5">
            <h2>Store Listings</h2>
            <br />
            <v-row>
              <v-col sm="4">
                <v-autocomplete
                  ref="store"
                  outlined
                  v-model="form.store_ids"
                  :items="storeItems"
                  label="Stores"
                  multiple
                  prepend-inner-icon="mdi-account"
                  deletable-chips
                  small-chips
                  clearable
                  :error-messages="errors.store_id"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </template>
          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Save User
          </v-btn>
        </v-card-text>
      </v-card>
      <!-- <v-dialog v-model="dialogVisible" max-width="500">
        <v-card>
          <v-card-title class="headline text-red-600"> Error </v-card-title>

          <v-card-text>
            {{ dialogMessage }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogVisible = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
    </v-container>
    <v-dialog v-model="dialogVisible" width="600" height="1000">
      <v-card rounded="xxl">
        <v-container>
          <v-row align="center">
            <v-col sm="3" align="center">
              <v-icon
                large
                style="color: red; font-size: 100px; width: 200px !important"
              >
                mdi-alert-remove-outline
              </v-icon>
            </v-col>
            <v-col sm="9" align="center">
              <v-card-text>
                <v-row>
                  <v-col>
                    <h1 style="color: red">OOPS!</h1>
                    <br />
                    <h3>{{ dialogMessage }}</h3>
                    <br />
                    <v-btn color="red" @click="dialogVisible = false">
                      OK
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "UserCreatePage",
  data() {
    return {
      form: {
        given_points: 0,
        is_active: true,
        soft_password: "123456",
        address: "",
        gst_type: "",
        loan_limit_amount: 0,
        balance_amount: 0,
        action_type: 0,
        set_limit: 0,
        is_loan_approved: 0,
        date: "",
        wallet: "",
        store_ids: "",
        // set_limit: "",

        earned_point: 0,
      },
      dialogVisible: false,
      dialogMessage: "",
      isLoading: false,

      actionItems: [
        { id: 0, text: "Select Action Type", value: 0 },
        { id: 2, text: "+ Increase", value: 1 },
        { id: 3, text: "- Decrease", value: 2 },
      ],
      gstItems: [
        {
          id: "Unregistered/Consumer",
          text: "Unregistered/Consumer",
          value: 1,
        },
        { id: "Registered-Regular", text: "Registered-Regular", value: 2 },
        { id: "Registered-Composite", text: "Registered-Composite", value: 3 },
      ],
      supervisorDownlined: [
        "Field Executive",
        "Merchandiser",
        "Promoter",
        "Van Sales",
      ],
      companyId: "",
      positionItems: [],
      storeItems: [],
      menu: false,
      // isLoading: false,
      typeItems: [
        { id: "PENDING", text: "PENDING", value: 0 },
        { id: "APPROVED", text: "APPROVED", value: 1 },
      ],
      statusItems: [
        { text: "Pending", value: 0 },
        { text: "Completed", value: 1 },
        { text: "Reject", value: 2 },
      ],
    };
  },
  mounted() {
    this.form.company_id = this.company.id;
    this.form.role_id = "3";
    console.log(this.companyId);
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`users/masters`)
        .then((masters) => {
          masters = masters.data;
          // Position
          masters.positions.forEach((position) => {
            this.positionItems.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });

          // Stores
          masters.stores.forEach((store) => {
            this.storeItems.push({
              id: store.id,
              text: store.store_location,
              value: store.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },

    async save() {
      try {
        this.isLoading = true;
        this.form.set_limit =
          this.form.set_limit == 0 ? "" : this.form.set_limit;

        const response = await axios.post("/users", this.form);

        // Check if the request was successful based on the response data
        if (response.data.success) {
          console.log("User created successfully", response.data);
          this.user = response.data; // Store user data if needed
          await this.saveUserTimestamp(null, this.form);
          this.$router.push("/users");
        } else {
          const errorMessage = response.data.message || "Operation failed";
          this.dialogMessage = errorMessage;
          this.dialogVisible = true;
        }
      } catch (e) {
        // This will catch network errors or HTTP errors (like 400, 500)
        const errorMessage = e.response?.data?.message || "An error occurred";
        console.error("Error creating user:", errorMessage);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script> 
